"use client";
import React from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/navigation";
import { getAndStoreVersion } from "../utils/functions";
import { PATHS_B } from "../get-started-v3/constants";
import "../../components/landing/style.scss";

const FaqSection = dynamic(
  () => import("../../components/landing/sections/faqSection"),
  {
    ssr: false,
  }
);
const ClaimingForSection = dynamic(
  () => import("../../components/landing/sections/claimingForSection"),
  {
    ssr: false,
  }
);
const FeaturedSection = dynamic(
  () => import("../../components/landing/sections/featuredSection"),
  {
    ssr: false,
  }
);
const SimpleStepsSection = dynamic(
  () => import("../../components/landing/sections/simpleStepsSection"),
  {
    ssr: false,
  }
);

export default function HowItWorks() {
  const router = useRouter();

  const initJourney = () => {
    getAndStoreVersion();
    router.push(PATHS_B.CLAIM);
  };

  return (
    <div>
      <div className="text-center text-3xl md:text-5xl font-semibold bg-primary-light py-4 md:py-5 bg-gradient-to-r from-[#00B86A] to-[#00522F] text-white">
        How it works
      </div>
      <SimpleStepsSection noImgOnMobile />
      <FeaturedSection />
      <ClaimingForSection initJourney={initJourney} backToform />
      <FaqSection initJourney={initJourney} />
    </div>
  );
}
